import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { sessionQueries } from '@/api';
import { DashboardPage } from '@/features/dashboard/dashboard-page';
import { useSession } from '@/hooks/use-session';

export const Route = createFileRoute('/dashboard')({
	/** Спека §13: сесія завершилась → Log in, після входу повернення сюди. */
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/dashboard' } });
	},
	component: DashboardRoute,
	staticData: { workspace: true },
});

function DashboardRoute(): ReactNode {
	const { user } = useSession();
	// beforeLoad уже гарантував сесію; до першого рендера хука вона вже в кеші.
	return user ? <DashboardPage user={user} /> : null;
}
